// Libraries
import { Grid, Skeleton } from "@mui/material";

export default function LotAreaSkeleton() {
	return (
		<Grid container className="!gap-8 mt-8">
			{Array.from({ length: 6 }, (_, index) => ({ name: `Lot ${index + 1}` })).map((_skeleton) => (
				<Grid item xs={1.6} key={_skeleton.name}>
					<Skeleton variant="rounded" className="w-full" height={120} />
				</Grid>
			))}
		</Grid>
	);
}
